const productData = [
  {
    id: 1,
    name: "Trail Ripstop Adjustable Jacket - Green",
    category: "Jackets",
    price: "179.00",
    reviews: "128",
    rating: "4.8",
    image: "/generated/products/product-01-a.webp",
    images: ["/generated/products/product-01-a.webp", "/generated/products/product-01-b.webp"],
    size: ["Medium", "Large"],
    colors: ["Green"],
    material: "100% Aramid Shell, 100% Nylon Liner",
    description: [
      "The Trail Ripstop Adjustable Jacket combines technical performance with practical design for demanding outdoor conditions.",
      "Built from durable ripstop fabric, this adaptable system includes a detachable insulated liner that delivers warmth without unnecessary weight.",
      "The generous, relaxed silhouette accommodates multiple layers and unrestricted movement, while thoughtful details including a chest pocket, side hand warmers, ventilated back pocket, and corduroy accents serve real-world functionality.",
      "Adjustable hood and hem provide adaptive fit across variable weather patterns.",
      "An intelligent investment for serious outdoor adventurers seeking reliable performance through autumn and winter seasons."
    ],
    Features: [
      "Materials: Shell: 100% Aramid, Liner: 100% Nylon, Filling: 100% Polyester",
      "Care: Wash cold, air dry",
      "Inherent flame resistance for campfire safety",
      "Detachable insulated liner for 3-way versatility",
      "Multiple utilitarian pockets including a ventilated back pocket"
    ]
  },
  {
    id: 2,
    name: "Field Minimal Blazer Cotton Blend - Khaki",
    category: "Jackets",
    price: "169.00",
    reviews: "85",
    rating: "4.6",
    image: "/generated/products/product-02-a.webp",
    images: ["/generated/products/product-02-a.webp", "/generated/products/product-02-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Khaki"],
    material: "Reinforced Cotton Blend",
    description: [
      "A refined minimal blazer crafted from a durable reinforced cotton blend for exceptional longevity.",
      "The structured yet relaxed fit makes it an ideal transitional piece for both smart and casual occasions.",
      "Features unlined construction for breathability and comfort during warmer months or heavy layering.",
      "Patch pockets add a touch of utilitarian charm to the classic blazer silhouette.",
      "Designed with everyday wear in mind, seamlessly blending functionality with timeless style."
    ],
    Features: [
      "Durable reinforced cotton blend fabric",
      "Unlined construction for easy layering",
      "Three exterior patch pockets",
      "Notched lapel with single-breasted button closure",
      "Machine washable on gentle cycle"
    ]
  },
  {
    id: 3,
    name: "Weatherproof Collar Coat - Dark Navy",
    category: "Coats",
    price: "175.00",
    reviews: "112",
    rating: "4.9",
    image: "/generated/products/product-03-a.webp",
    images: ["/generated/products/product-03-a.webp", "/generated/products/product-03-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Dark Navy"],
    material: "Breathable Windproof Laminate",
    description: [
      "A high-performance collar coat engineered with a breathable windproof laminate for dependable weather protection.",
      "Offers complete windproof performance while maintaining exceptional breathability to prevent overheating.",
      "The sleek, minimalist exterior hides advanced technical features, making it suitable for city commutes and weekend excursions.",
      "A tailored fit ensures a sharp silhouette over suits or casual wear.",
      "Equipped with concealed weather-resistant zippers and secure internal storage."
    ],
    Features: [
      "Breathable laminate for complete windproof protection",
      "Highly breathable fabric prevents moisture buildup",
      "Classic point collar with hidden throat latch",
      "Water-resistant finish for light rain protection",
      "Concealed button placket for a streamlined look"
    ]
  },
  {
    id: 4,
    name: "Evening Dinner Jacket - Peat",
    category: "Jackets",
    price: "168.00",
    reviews: "64",
    rating: "4.7",
    image: "/generated/products/product-04-a.webp",
    images: ["/generated/products/product-04-a.webp", "/generated/products/product-04-b.webp"],
    size: ["48", "50", "52", "54"],
    colors: ["Peat"],
    material: "Premium Wool Blend",
    description: [
      "An elegant reinterpretation of the classic dinner jacket, presented in a versatile peat hue.",
      "Expertly tailored from a premium wool blend that drapes beautifully and resists creasing.",
      "Features subtle satin lapel detailing that catches the light, adding a touch of evening sophistication.",
      "The modern, slightly cropped cut pairs perfectly with high-waisted trousers.",
      "Fully lined with smooth cupro for effortless wear over shirts and fine knitwear."
    ],
    Features: [
      "Premium wool blend with natural wrinkle resistance",
      "Contrast satin lapels and pocket trims",
      "Fully lined in breathable cupro",
      "Single-button closure for a clean profile",
      "Expertly tailored for a modern, flattering fit"
    ]
  },
  {
    id: 5,
    name: "Structured Officer Jacket - Black",
    category: "Jackets",
    price: "165.00",
    reviews: "92",
    rating: "4.5",
    image: "/generated/products/product-05-a.webp",
    images: ["/generated/products/product-05-a.webp", "/generated/products/product-05-b.webp"],
    size: ["M", "L", "XL"],
    colors: ["Black"],
    material: "Heavyweight Cotton Twill",
    description: [
      "A commanding officer-style jacket that brings military-inspired structure to your everyday wardrobe.",
      "Constructed from heavyweight cotton twill that softens uniquely over time while retaining its shape.",
      "Features a stand collar and symmetrical chest pockets that emphasize its uniform origins.",
      "The boxy fit allows for substantial layering beneath during colder months.",
      "Finished with robust, custom-molded hardware for lasting durability."
    ],
    Features: [
      "Heavyweight cotton twill construction",
      "Military-inspired stand collar",
      "Symmetrical flap pockets at the chest",
      "Robust custom-molded buttons",
      "Boxy, layer-friendly silhouette"
    ]
  },
  {
    id: 6,
    name: "Herringbone Double-Breasted Coat - Green",
    category: "Coats",
    price: "178.00",
    reviews: "156",
    rating: "4.8",
    image: "/generated/products/product-06-a.webp",
    images: ["/generated/products/product-06-a.webp", "/generated/products/product-06-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Green Herringbone"],
    material: "Wool Herringbone Tweed",
    description: [
      "A majestic double-breasted coat crafted from rich green herringbone tweed.",
      "The substantial wool fabric provides exceptional warmth and a beautifully textured appearance.",
      "Designed with an elongated silhouette and a dramatic peak lapel for maximum sartorial impact.",
      "Features a traditional martingal back belt to cinch the waist and enhance the drape.",
      "A timeless investment piece that pays homage to classic British outerwear traditions."
    ],
    Features: [
      "Heavyweight wool herringbone tweed",
      "Classic double-breasted fastening",
      "Wide peak lapels for a distinguished look",
      "Functional martingal half-belt at the back",
      "Deep welt pockets for hand-warming"
    ]
  },
  {
    id: 7,
    name: "Double Breasted Jacket - Indigo Blue",
    category: "Jackets",
    price: "159.00",
    reviews: "78",
    rating: "4.6",
    image: "/generated/products/product-07-a.webp",
    images: ["/generated/products/product-07-a.webp", "/generated/products/product-07-b.webp"],
    size: ["46", "48", "50", "52"],
    colors: ["Indigo Blue"],
    material: "Cotton-Linen Blend",
    description: [
      "A relaxed double-breasted jacket washed in a deep, garment-dyed indigo blue.",
      "The cotton-linen blend fabric offers the perfect balance of structure and warm-weather breathability.",
      "Unstructured shoulders and a softer chest canvas create an effortlessly casual drape.",
      "The indigo dye is designed to fade gently over time, creating a unique patina personal to the wearer.",
      "Pairs exceptionally well with matching trousers or contrasting light denim."
    ],
    Features: [
      "Garment-dyed indigo finish that ages beautifully",
      "Breathable cotton-linen blend ideal for transitional weather",
      "Unstructured tailoring for a relaxed fit",
      "Six-button double-breasted front",
      "Patch pockets for a casual aesthetic"
    ]
  },
  {
    id: 8,
    name: "Fireman's Jacket - Black",
    category: "Jackets",
    price: "169.00",
    reviews: "104",
    rating: "4.7",
    image: "/generated/products/product-08-a.webp",
    images: ["/generated/products/product-08-a.webp", "/generated/products/product-08-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Black"],
    material: "Waxed Cotton Canvas",
    description: [
      "An iconic fireman's jacket reimagined for the modern urban environment.",
      "Crafted from robust waxed cotton canvas that naturally repels wind and rain.",
      "Features the signature quick-release metal clasp closures that define the style's heritage.",
      "A corduroy-lined collar provides comfort against the neck and adds a touch of textural contrast.",
      "Generous patch pockets offer ample storage for daily essentials."
    ],
    Features: [
      "Weather-resistant waxed cotton canvas",
      "Authentic quick-release metal clasps",
      "Soft corduroy-lined collar",
      "Storm flap for added wind protection",
      "Large capacity dual-entry front pockets"
    ]
  },
  {
    id: 9,
    name: "Short Raglan Coat - Navy",
    category: "Coats",
    price: "158.00",
    reviews: "142",
    rating: "4.8",
    image: "/generated/products/product-09-a.webp",
    images: ["/generated/products/product-09-a.webp", "/generated/products/product-09-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Navy"],
    material: "Water-Repellent Gabardine",
    description: [
      "A versatile short coat featuring raglan sleeves for superior mobility and a relaxed shoulder line.",
      "Cut from a premium water-repellent gabardine that stands up to unpredictable spring showers.",
      "The mid-thigh length provides excellent coverage without restricting movement.",
      "Hidden button placket maintains a clean, minimalist exterior.",
      "Fully lined in a contrasting check pattern for a subtle nod to heritage outerwear."
    ],
    Features: [
      "Raglan sleeve construction for ease of movement",
      "Water-repellent gabardine fabric",
      "Concealed front button fastening",
      "Adjustable button tabs at the cuffs",
      "Heritage-inspired check lining"
    ]
  },
  {
    id: 10,
    name: "Waxed Leisure Camo Jacket - Camo",
    category: "Jackets",
    price: "149.00",
    reviews: "67",
    rating: "4.4",
    image: "/generated/products/product-10-a.webp",
    images: ["/generated/products/product-10-a.webp", "/generated/products/product-10-b.webp"],
    size: ["M", "L", "XL"],
    colors: ["Camo"],
    material: "Waxed Cotton",
    description: [
      "A rugged leisure jacket presented in a subtle, custom-developed camouflage pattern.",
      "The waxed cotton finish provides excellent weather resistance and develops a unique character with wear.",
      "Features a protective corduroy collar and throat latch for brisk mornings.",
      "Multiple utility pockets ensure your gear is always securely stowed.",
      "Ideal for outdoor pursuits or adding a utilitarian edge to city styling."
    ],
    Features: [
      "Custom camouflage printed waxed cotton",
      "Weather and wind resistant finish",
      "Contrasting corduroy collar with throat latch",
      "Two-way brass zip with snap storm flap",
      "Spacious bellows pockets with drainage holes"
    ]
  },
  {
    id: 11,
    name: "Classic Chukka Boot - Black",
    category: "Shoes",
    price: "145.00",
    reviews: "215",
    rating: "4.9",
    image: "/generated/products/product-11-a.webp",
    images: ["/generated/products/product-11-a.webp", "/generated/products/product-11-b.webp"],
    size: ["40", "41", "42", "43", "44"],
    colors: ["Black"],
    material: "Full-Grain Leather",
    description: [
      "A sophisticated take on the classic chukka boot, rendered in polished black full-grain leather.",
      "Expertly crafted with a sleek profile that bridges the gap between casual and formal wear.",
      "Features a durable yet flexible rubber sole for all-day comfort and superior traction.",
      "Fully lined in soft calfskin that molds comfortably to the foot over time.",
      "The perfect foundational footwear piece for any versatile wardrobe."
    ],
    Features: [
      "Premium full-grain leather upper",
      "Comfortable calfskin lining",
      "Durable rubber outsole for city walking",
      "Two-eyelet lace-up design",
      "Blake stitched construction for longevity"
    ]
  },
  {
    id: 12,
    name: "Relaxed Suit Jacket - Grey",
    category: "Jackets",
    price: "155.00",
    reviews: "89",
    rating: "4.6",
    image: "/generated/products/product-12-a.webp",
    images: ["/generated/products/product-12-a.webp", "/generated/products/product-12-b.webp"],
    size: ["46", "48", "50", "52"],
    colors: ["Grey"],
    material: "Lightweight Wool Twill",
    description: [
      "A modern, adaptable suit jacket cut from a lightweight grey wool twill.",
      "Designed to be worn seamlessly as a separate or paired with matching trousers.",
      "Features a softly constructed shoulder that follows the natural line of the body.",
      "The breathable fabric ensures comfort during long office days or summer events.",
      "Finished with elegant horn buttons and functional cuff buttonholes."
    ],
    Features: [
      "Lightweight and breathable wool twill",
      "Softly tailored unstructured shoulders",
      "Notched lapels and flap pockets",
      "Genuine horn buttons throughout",
      "Double back vents for ease of movement"
    ]
  },
  {
    id: 13,
    name: "Coastal Seersucker Jacket - Ocean Stripe",
    category: "Jackets",
    price: "135.00",
    reviews: "54",
    rating: "4.7",
    image: "/generated/products/product-13-a.webp",
    images: ["/generated/products/product-13-a.webp", "/generated/products/product-13-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Ocean Stripe"],
    material: "Cotton Seersucker",
    description: [
      "The ultimate warm-weather jacket, crafted from classic crinkled cotton seersucker.",
      "The distinctive puckered texture holds the fabric away from the skin, facilitating air circulation.",
      "Features a relaxed, unlined construction that feels as light as a shirt.",
      "The ocean stripe pattern brings a refreshing, nautical-inspired aesthetic to summer tailoring.",
      "Perfect for garden parties, destination weddings, or elevated vacation dressing."
    ],
    Features: [
      "Breathable, textured cotton seersucker fabric",
      "Completely unlined for maximum cooling",
      "Refreshing ocean blue and white stripe pattern",
      "Three patch pockets for a casual look",
      "Naturally wrinkle-concealing fabric"
    ]
  },
  {
    id: 14,
    name: "Wool & Cashmere Jacket - Deep Navy",
    category: "Jackets",
    price: "175.00",
    reviews: "134",
    rating: "4.9",
    image: "/generated/products/product-14-a.webp",
    images: ["/generated/products/product-14-a.webp", "/generated/products/product-14-b.webp"],
    size: ["48", "50", "52", "54"],
    colors: ["Jarman Navy"],
    material: "Virgin Wool and Cashmere Blend",
    description: [
      "A luxuriously soft jacket tailored from an exquisite blend of virgin wool and cashmere.",
      "The rich 'Jarman Navy' hue offers incredible depth of color and versatility.",
      "Impeccably tailored with a half-canvas construction that molds perfectly to the wearer's shape.",
      "The plush fabric provides excellent insulation while remaining remarkably lightweight.",
      "An essential piece that instantly elevates any smart-casual or formal ensemble."
    ],
    Features: [
      "Ultra-soft virgin wool and cashmere blend",
      "Half-canvas construction for superior drape",
      "Rich, deep navy coloration",
      "Fully lined in tonal cupro",
      "Hand-finished lapel buttonhole"
    ]
  },
  {
    id: 15,
    name: "Heavyweight Hoody Jacket - Black",
    category: "Outerwear",
    price: "128.00",
    reviews: "176",
    rating: "4.8",
    image: "/generated/products/product-15-a.webp",
    images: ["/generated/products/product-15-a.webp", "/generated/products/product-15-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Black"],
    material: "Heavyweight Cotton Fleece",
    description: [
      "A substantial zip-up hoody that bridges the gap between premium loungewear and outerwear.",
      "Constructed from a densely knit heavyweight cotton fleece that provides exceptional warmth and structure.",
      "Features a robust two-way zip and a double-layered hood that holds its shape when worn down.",
      "The relaxed fit accommodates layering while maintaining a clean, modern silhouette.",
      "Finished with reinforced seams and heavy-duty ribbed trims for enduring quality."
    ],
    Features: [
      "Dense, heavyweight cotton fleece",
      "Structured, double-layered hood",
      "Premium two-way metal zipper",
      "Spacious split kangaroo pocket",
      "Heavy-duty ribbed cuffs and hem"
    ]
  },
  {
    id: 16,
    name: "Utility Chore Jacket Cotton Linen - Navy",
    category: "Jackets",
    price: "142.00",
    reviews: "118",
    rating: "4.6",
    image: "/generated/products/product-16-a.webp",
    images: ["/generated/products/product-16-a.webp", "/generated/products/product-16-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Navy"],
    material: "Cotton-Linen Canvas",
    description: [
      "A military-inspired take on the classic chore jacket, rendered in a durable cotton-linen canvas.",
      "The fabric combines the strength of cotton with the breathability and unique texture of linen.",
      "Garment-washed for a remarkably soft hand-feel and a subtly broken-in appearance from day one.",
      "Features utilitarian detailing including reinforced elbows and multiple tool-sized pockets.",
      "A versatile, hard-wearing layer that gets better with every wash and wear."
    ],
    Features: [
      "Durable and breathable cotton-linen canvas",
      "Garment-washed for instant comfort",
      "Four utilitarian patch pockets",
      "Reinforced elbow patches for longevity",
      "Corozo nut buttons"
    ]
  },
  {
    id: 17,
    name: "Washed Denim Jacket - Brown",
    category: "Jackets",
    price: "139.00",
    reviews: "82",
    rating: "4.5",
    image: "/generated/products/product-17-a.webp",
    images: ["/generated/products/product-17-a.webp", "/generated/products/product-17-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Brown"],
    material: "13oz Japanese Denim",
    description: [
      "A fresh perspective on the classic trucker jacket, constructed from robust 13oz Japanese denim in a rich earthy brown.",
      "The unique colorway offers a sophisticated alternative to traditional indigo, pairing beautifully with neutral tones.",
      "Features classic Type III detailing including V-shaped front seams and dual chest flap pockets.",
      "The rigid denim will soften and fade uniquely to the wearer, creating highly personalized wear patterns.",
      "Finished with custom copper hardware and a plain leather patch."
    ],
    Features: [
      "Premium 13oz brown Japanese denim",
      "Classic Type III trucker silhouette",
      "Custom copper shank buttons",
      "Adjustable waist tabs",
      "Two chest pockets and two side hand pockets"
    ]
  },
  {
    id: 18,
    name: "Boucle Knit Vest - Aubergine",
    category: "Knitwear",
    price: "98.00",
    reviews: "45",
    rating: "4.8",
    image: "/generated/products/product-18-a.webp",
    images: ["/generated/products/product-18-a.webp", "/generated/products/product-18-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Aubergine"],
    material: "Cotton Boucle Knit",
    description: [
      "A highly textural knit vest crafted from a distinctive aubergine cotton boucle yarn.",
      "The looped boucle texture provides visual interest and a wonderfully tactile, spongy feel.",
      "Designed with a slightly relaxed fit that layers effortlessly over crisp shirting or simple tees.",
      "The deep, rich aubergine color adds a sophisticated pop of tone to neutral outfits.",
      "Finished with chunky ribbed trims at the neck, armholes, and hem for structure."
    ],
    Features: [
      "Highly textural cotton boucle yarn",
      "Rich, deep aubergine coloration",
      "Relaxed fit for easy layering",
      "Chunky ribbed collar, armholes, and hem",
      "Breathable cotton construction suitable for year-round wear"
    ]
  },
  {
    id: 19,
    name: "Chalk Stripe Overshirt - Black",
    category: "Shirts",
    price: "118.00",
    reviews: "93",
    rating: "4.7",
    image: "/generated/products/product-19-a.webp",
    images: ["/generated/products/product-19-a.webp", "/generated/products/product-19-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Black Chalk"],
    material: "Heavyweight Cotton Flannel",
    description: [
      "A substantial overshirt featuring a subtle chalk stripe pattern on a deep black base.",
      "Cut from a heavyweight cotton flannel that provides jacket-like warmth with shirt-like comfort.",
      "The slightly oversized fit is designed specifically to accommodate layers underneath.",
      "Features a straight hem and side slits, allowing it to be worn easily untucked.",
      "A versatile layering piece that transitions seamlessly between indoor lounging and outdoor excursions."
    ],
    Features: [
      "Heavyweight, brushed cotton flannel",
      "Subtle chalk stripe pattern",
      "Oversized fit for easy layering",
      "Straight hem with side slits",
      "Two large chest patch pockets"
    ]
  },
  {
    id: 20,
    name: "Relaxed Trousers - Chalk Stripe",
    category: "Trousers",
    price: "112.00",
    reviews: "114",
    rating: "4.6",
    image: "/generated/products/product-20-a.webp",
    images: ["/generated/products/product-20-a.webp", "/generated/products/product-20-b.webp"],
    size: ["30", "32", "34", "36"],
    colors: ["Chalk Stripe"],
    material: "Wool Blend Twill",
    description: [
      "Distinctive wide-leg trousers featuring an elegant chalk stripe pattern.",
      "The generous, flowing silhouette draws inspiration from traditional martial arts garments, offering unparalleled freedom of movement.",
      "Crafted from a fluid wool blend that drapes beautifully while maintaining a crisp front crease.",
      "Features a comfortable elasticated waistband with an internal drawstring for a customized fit.",
      "Pairs perfectly with minimal knitwear or the matching overshirt for a relaxed tailored look."
    ],
    Features: [
      "Wide, flowing leg silhouette",
      "Classic chalk stripe pattern",
      "Elasticated waist with internal drawcord",
      "Fluid wool blend fabric with excellent drape",
      "Deep side slip pockets and rear welt pockets"
    ]
  },
  {
    id: 21,
    name: "Textured Knitted Sweater - Blue",
    category: "Knitwear",
    price: "105.00",
    reviews: "167",
    rating: "4.9",
    image: "/generated/products/product-21-a.webp",
    images: ["/generated/products/product-21-a.webp", "/generated/products/product-21-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Blue"],
    material: "Merino Wool Blend",
    description: [
      "A beautifully textured crewneck sweater knitted in a vibrant, multi-tonal blue yarn.",
      "The premium merino wool blend offers exceptional warmth, softness, and natural temperature regulation.",
      "Features a distinctive textured stitch that gives the garment depth and a lofty, cozy feel.",
      "The classic, regular fit makes it an incredibly versatile daily staple.",
      "Finished with shape-retaining ribbed cuffs, hem, and neckline."
    ],
    Features: [
      "Soft, temperature-regulating merino wool blend",
      "Distinctive textured knit structure",
      "Vibrant multi-tonal blue coloration",
      "Classic crew neckline",
      "Shape-retaining ribbed trims"
    ]
  },
  {
    id: 22,
    name: "Canvas Work Jacket - Indigo Blue",
    category: "Jackets",
    price: "132.00",
    reviews: "88",
    rating: "4.7",
    image: "/generated/products/product-22-a.webp",
    images: ["/generated/products/product-22-a.webp", "/generated/products/product-22-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Indigo Blue"],
    material: "Cotton Canvas",
    description: [
      "A streamlined, workwear-inspired jacket rendered in a rich indigo blue cotton canvas.",
      "The unlined, lightweight construction makes it an ideal piece for mild weather or indoor layering.",
      "Features a clean, button-front design with minimal detailing for a contemporary, pared-back aesthetic.",
      "The durable canvas fabric is designed to soften and develop character with regular use.",
      "A highly practical and effortlessly stylish addition to any casual rotation."
    ],
    Features: [
      "Durable, lightweight cotton canvas",
      "Rich indigo blue coloration",
      "Clean, minimal workwear aesthetic",
      "Unlined for breathability",
      "Practical front patch pockets"
    ]
  },
  {
    id: 23,
    name: "Linen Short Sleeve Shirt - Indigo",
    category: "Shirts",
    price: "89.00",
    reviews: "105",
    rating: "4.6",
    image: "/generated/products/product-23-a.webp",
    images: ["/generated/products/product-23-a.webp", "/generated/products/product-23-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Indigo"],
    material: "Lightweight Linen",
    description: [
      "A relaxed short-sleeve shirt crafted from airy, lightweight linen in a deep indigo hue.",
      "The highly breathable fabric and boxy cut ensure maximum comfort during the hottest days.",
      "Features a relaxed camp collar that sits open for a laid-back, vacation-ready look.",
      "The garment-dyed finish provides a rich, slightly washed appearance that enhances the casual feel.",
      "Perfectly paired with shorts or lightweight summer trousers."
    ],
    Features: [
      "Highly breathable, lightweight linen",
      "Relaxed camp collar design",
      "Boxy, comfortable fit",
      "Garment-dyed for a rich, nuanced color",
      "Single chest patch pocket"
    ]
  },
  {
    id: 24,
    name: "Quilted Travel Blanket - Black",
    category: "Accessories",
    price: "79.00",
    reviews: "143",
    rating: "4.9",
    image: "/generated/products/product-24-a.webp",
    images: ["/generated/products/product-24-a.webp", "/generated/products/product-24-b.webp"],
    size: ["One Size"],
    colors: ["Black / Grey Pattern"],
    material: "Recycled Wool Blend",
    description: [
      "A premium, exceptionally warm blanket designed for travel and quiet evenings outdoors.",
      "Crafted from a thick, recycled wool blend that provides outstanding insulation around the campfire or on the sofa.",
      "Features a striking geometric pattern in versatile black and grey tones.",
      "The durable construction is designed to withstand the rigors of outdoor use while remaining soft enough for home comfort.",
      "Generously sized to comfortably wrap around two people or cover a queen-sized bed."
    ],
    Features: [
      "Exceptional warmth from a thick wool blend",
      "Eco-friendly recycled materials",
      "Striking, reversible geometric pattern",
      "Durable edge finishing to prevent fraying",
      "Generous dimensions for versatile use"
    ]
  },
  {
    id: 25,
    name: "Brushed Wool Overshirt - Rust",
    category: "Shirts",
    price: "126.00",
    reviews: "76",
    rating: "4.7",
    image: "/generated/products/product-25-a.webp",
    images: ["/generated/products/product-25-a.webp", "/generated/products/product-25-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Rust"],
    material: "Brushed Wool Blend",
    description: [
      "A warm overshirt in a rich rust tone, cut with enough room for effortless layering.",
      "The softly brushed wool blend balances insulation with a comfortable, lightweight feel."
    ],
    Features: ["Soft brushed wool-blend fabric", "Two practical chest pockets", "Relaxed layering fit"]
  },
  {
    id: 26,
    name: "Pleated Cotton Trousers - Stone",
    category: "Trousers",
    price: "108.00",
    reviews: "63",
    rating: "4.6",
    image: "/generated/products/product-26-a.webp",
    images: ["/generated/products/product-26-a.webp", "/generated/products/product-26-b.webp"],
    size: ["30", "32", "34", "36"],
    colors: ["Stone"],
    material: "Washed Cotton Twill",
    description: [
      "Relaxed stone cotton trousers shaped with front pleats and a clean tapered leg.",
      "Garment washing gives the durable twill a soft hand from the first wear."
    ],
    Features: ["Washed cotton twill", "Double front pleats", "Comfortable tapered silhouette"]
  },
  {
    id: 27,
    name: "Cable Knit Cardigan - Cream",
    category: "Knitwear",
    price: "119.00",
    reviews: "91",
    rating: "4.8",
    image: "/generated/products/product-27-a.webp",
    images: ["/generated/products/product-27-a.webp", "/generated/products/product-27-b.webp"],
    size: ["S", "M", "L"],
    colors: ["Cream"],
    material: "Wool Cotton Blend",
    description: [
      "A substantial cream cardigan with a tactile cable-knit structure and relaxed proportions.",
      "The balanced wool-cotton yarn provides warmth while remaining comfortable indoors."
    ],
    Features: ["Textured cable knit", "Warm wool-cotton yarn", "Ribbed cuffs and hem"]
  },
  {
    id: 28,
    name: "Utility Field Vest - Olive",
    category: "Outerwear",
    price: "96.00",
    reviews: "58",
    rating: "4.6",
    image: "/generated/products/product-28-a.webp",
    images: ["/generated/products/product-28-a.webp", "/generated/products/product-28-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Olive"],
    material: "Cotton Ripstop",
    description: [
      "A lightweight olive field vest designed to add storage and structure without unnecessary bulk.",
      "Durable cotton ripstop and carefully placed pockets make it a useful everyday layer."
    ],
    Features: ["Durable cotton ripstop", "Multiple utility pockets", "Adjustable side tabs"]
  },
  {
    id: 29,
    name: "Merino Rollneck Sweater - Charcoal",
    category: "Knitwear",
    price: "115.00",
    reviews: "109",
    rating: "4.9",
    image: "/generated/products/product-29-a.webp",
    images: ["/generated/products/product-29-a.webp", "/generated/products/product-29-b.webp"],
    size: ["S", "M", "L", "XL"],
    colors: ["Charcoal"],
    material: "Merino Wool",
    description: [
      "A refined charcoal rollneck knitted from fine merino wool for soft, breathable warmth.",
      "Its clean regular fit works equally well beneath tailoring or as a standalone layer."
    ],
    Features: ["Fine merino wool", "Comfortable roll neckline", "Clean regular fit"]
  },
  {
    id: 30,
    name: "Canvas Weekend Tote - Sand",
    category: "Accessories",
    price: "72.00",
    reviews: "72",
    rating: "4.7",
    image: "/generated/products/product-30-a.webp",
    images: ["/generated/products/product-30-a.webp", "/generated/products/product-30-b.webp"],
    size: ["One Size"],
    colors: ["Sand"],
    material: "Heavyweight Cotton Canvas",
    description: [
      "A spacious sand canvas tote designed for short trips, daily commutes and market runs.",
      "Reinforced handles and a structured base support everyday loads while retaining a clean profile."
    ],
    Features: ["Heavyweight cotton canvas", "Reinforced carry handles", "Internal organiser pocket"]
  }
];

export default productData;
